


export function grabHeroNew(response,currentCharacterInfo){
        var APISuccess;
        var newCharacterInfoArray = [];

        //console.log("Last Character Data:");
        //console.log(currentCharacterInfo);
            try{
                newCharacterInfoArray = [
                    response.data.data.results[0].name,
                    response.data.data.results[0].description,
                    response.data.data.results[0].thumbnail.path +"."+ response.data.data.results[0].thumbnail.extension,
                    response.data.data.results[0].id
                ];
                
                APISuccess = true; 
                //console.log("NEW STYLE HERO ARRAY: " + newCharacterInfoArray);

              

            }//end try
            catch(err) {
                alert("I dont have any data for that name. \n The character may not exist or you're misspelling it. \n You can check character database to find who you're looking for. ");
                console.log(err);
                APISuccess = false;


                //this is a cheap hack. the sectionFeaturedComic module wont render anything unless 
                //the searched name is different than the current one. This is for infinite loop prevention. 
                //by setting the data to 'misspelled', it bypasses that check, then rerenders the current 
                //correct data
                newCharacterInfoArray = [
                    'misspelled',
                    'misspelled',
                    'misspelled',
                    'misspelled'
                ];

                return newCharacterInfoArray;
                //return;
            }
 

       
            /*changeCharacter() is a dispatcher() in the characterReducer
            we cant call it directly here so im passing it as a param through grabHero(param)
            this way when grabHero() is called in another module, changeCharacter() will be waiting there
            as "this.changeCharacter = props.changeCharacter.bind(this);"*/
            if(APISuccess === true){
                if(newCharacterInfoArray[1] === ""){
                    newCharacterInfoArray[1] = 'I was unable to find anything on record describing ' + newCharacterInfoArray[0];
                }
                //get a new image later
                if(newCharacterInfoArray[2] === "http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available.jpg"){
                   // newCharacterInfoArray[2] = 'http://iv1.lisimg.com/image/14769078/740full-celine-farach.jpg'; 
                    newCharacterInfoArray[2] = 'http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available.jpg'; 
                }
                //console.log("IMAGE: " + newCharacterInfoArray[2]);
                
                
            }//end if()

     
            return newCharacterInfoArray;
}//end grabHero()



// WEBPACK FOOTER //
// ./src/components/includes/grabHeroNew.js